/**
 * Detect employees whose RBAC grants only self-service access (no elevated/admin patterns).
 * Shared by DashboardLayoutV2 and dashboard routing.
 */
export function hasSelfServicePermissionsOnly({
  permissions = [],
  isAdmin = false,
  isCompanyAdmin = false,
  isSuperadmin = false,
  permissionsLoading = false,
  modulesLoading = false,
} = {}) {
  if (isSuperadmin || isCompanyAdmin || isAdmin) return false;
  if (permissionsLoading || modulesLoading) return false;
  if (!permissions || permissions.length === 0) return true;

  const hasAdminPerms = permissions.some((perm) => isElevatedPermission(perm));

  return !hasAdminPerms;
}

function isElevatedPermission(perm) {
  if (perm === 'mobile.admin.view' || perm === 'incident.report.view_all') return false;
  const adminPatterns = ['_all', '.approve', '.manage', '.admin', '.create_any', '.edit_any', '.delete'];
  return adminPatterns.some((pattern) => perm.includes(pattern));
}
